<div class="relative google-reviews-wrap">
    <div class="google-reviews-title">
        <div>G</div>
        GOOGLE REVIEWS

        <mat-icon class="sort-icon" [matMenuTriggerFor]="menu" aria-label="sort">more_vert</mat-icon>

        <mat-menu #menu="matMenu" class="review-sort">
            <button mat-menu-item (click)="sortReview('recency')">
                <span>Recency</span>
            </button>
            <button mat-menu-item (click)="sortReview('relevancy')">
                <span>Relevancy</span>
            </button>
            <button mat-menu-item (click)="sortReview('highest_rating')">
                <span>Highest rating</span>
            </button>
            <button mat-menu-item (click)="sortReview('lowest_rating')">
                <span>Lowest rating</span>
            </button>
        </mat-menu>

    </div>

    <div *ngIf="!loading" wrap>
        <div *ngFor="let row of rows" class="flex">
            <div class="google-place-reviews" *ngFor="let review of row" [class.blank-wrap]="!review.profile_photo_url">
                <div *ngIf="review.profile_photo_url" class="post-title" [class.min-height]="columns>1">
                    <a class="profile-picture" target="_blank" [attr.href]="review.author_url">
                        <img [attr.src]="review.profile_photo_url" alt="">
                    </a>
                    <div class="post-content">
                        <a place target="_blank" [attr.href]="review.author_url">
                            {{review.author_name}}
                        </a>
                        <div class="post-message">
                            {{review.text&&(review.text.length > messageLength) ? review.text.substr(0, messageLength) +
                            '...' : review.text}}
                        </div>
                    </div>
                </div>

                <!--<img class="post-img" *ngIf="!!post.full_picture" [attr.src]="post.full_picture" alt="">-->
                <div class="post-footer">
                    <div>
                        <mat-icon *ngFor="let rate of review.stars">star</mat-icon>
                    </div>

                    <div>{{getTime(review)}}</div>
                </div>
            </div>
        </div>

        <div *ngIf="!reviews||(reviews&&!reviews.length)" class="no-content">No reviews available</div>
    </div>

    <ig-spinner *ngIf="loading"></ig-spinner>

    <ig-button *ngIf="googleLink&&!loading" size="md" class="google-btn" (trigger)="gotoGoogleList()">View Google
        Listing</ig-button>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/google.place/google.place.reviews/google.place.reviews.component.html